import { Navigate, Route, Routes } from 'react-router-dom';

import InspectorDashboard from '../pages/inspector/InspectorDashboard';
import InspectorInspectionDetail from '../pages/inspector/InspectorInspectionDetail';
import React from 'react';

const InspectorRoutes = () => {
  return (
    <Routes>
      {/* Dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<InspectorDashboard />} />

      {/* Inspections */}
      <Route path="/inspections/:id" element={<InspectorInspectionDetail />} />

      {/* Redirect any other routes to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default InspectorRoutes;